<template>
    <div class="down_popup" v-show="codeShow">
        <div class="popup_box">
            <img class="del" src="../../assets/images/del.png" alt="" @click="codeShow = false">
            <img class="qrcode" src="../../assets/images/download-qrcode.png?v5" alt="" />
        </div>
    </div>
</template>

<script>
export default {
    name: "adPopup",
    data(){
        return{
            codeShow:false
        }
    },
    created() {
        if(!this.$cookies.isKey('codeShow')){
            setTimeout(()=>{
                this.codeShow = true
                this.$cookies.set("codeShow","true","24h")
            },30000)
        }
    }
}
</script>

<style scoped>
.down_popup{
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(27,27,27,0.8);
    left: 0px;
    top: 0px;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;

}
.popup_box{
    width: 380px;
    height: 340px;
    position: relative;
    background: url("../../assets/images/code_bg.png");

}
.qrcode{
    width: 180px;
    height:180px;
    position: absolute;
    top: 63px;
    left: 109px;
}
.del{
    position: absolute;
    right: 0;
    top: -20px;
    cursor: pointer;
}
</style>